<template>
  <div class="container-view">
    <Breadcrumbs />

    <div class="row col-12 container-titles" style="display: flex">
      <div class="header-title col-10">Ámbito: {{ dataAmbito.name }}</div>
      <div class="col-2" style="padding-top: 24px; align-items: flex-end">
        <q-btn
          data-cy="save-ambito"
          style="width: 100%; margin-left: 0 !important"
          color="primary"
          label="Guardar"
          icon="save"
          @click="isNew ? emitNew() : emitgeneralSave()"
          :loading="isLoadingButton"
        />
      </div>
    </div>
    <div>
      <Edicion :dataAmbito="dataAmbito" :isNew="isNew" @created="isCreate" />
    </div>
    <div class="row col-12">
      <div class="col-12" id="group-container">
        <Verticales
          :dataAmbito="dataAmbito"
          :isNew="isNew"
          :arrayVertical="arrayVertical"
          :isLoadingVerticals="isLoadingVerticals"
          :verticalSuper="verticalSuper"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Message from '@/components/shared/mixins/Message.js';
import Validation from '@/components/shared/mixins/Validation.js';
import Loading from '@/components/shared/mixins/Loading.js';
import Edicion from '../components/Edicion.vue';
import Verticales from '../components/Verticales.vue';
import Breadcrumbs from '@/shared/breadcrumbs/Breadcrumbs.vue';

export default {
  components: {
    Edicion,
    Verticales,
    Breadcrumbs
  },
  mixins: [Message, Validation, Loading],
  data: function () {
    return {
      data: [],
      isLoading: false,
      dataAmbito: {},
      arrayVertical: [],
      verticalSuper: [],
      isLoadingVerticals: false,
      isNew: false,
      isLoadingButton: false,
      checkSave: {
        isInfoSave: null,
        isVerticalSave: null,
        existError: false
      }
    };
  },
  async created () {
    let idAmbito = this.$route.params.idAmbito
      ? this.$route.params.idAmbito
      : null;

    if (idAmbito !== null) {
      await this._callData(idAmbito);
    } else {
      this.isNew = true;
    }

    await this._getGrupo();
  },
  methods: {
    async emitNew () {
      this.resetSaved();
      await this.$eventHub.$emit('EJECUCION_NUEVO', {
        callback: x => {
          this.checkSave.isInfoSave = x.status;
          this.dataAmbito.id = x.data.id;
          this.$eventHub.$emit('EJECUCION_GUARDAR_VERTICALES', {
            callback: async x => {
              this.checkSave.isVerticalSave = x.status;
              this.checkSaved();
              this.isNew = false;

              // Load Data and prepare to components
              await this._callData(this.dataAmbito.id);

              // Change Page
              this.$router.push({
                name: 'form_ambito',
                params: { idAmbito: this.dataAmbito.id }
              });
            }
          });
        },
        rejected: x => {
          this.checkSave.isInfoSave = x.status;
          this.checkSaved();
        }
      });
    },
    async emitgeneralSave () {
      // Reset variables
      this.resetSaved();

      await this.$eventHub.$emit('ACTUALIZAR_INFORMACION', {
        callback: x => {
          this.checkSave.isInfoSave = x.status;
          this.checkSaved();
          this.$eventHub.$emit('EJECUCION_GUARDAR_VERTICALES', {
            callback: x => {
              this.checkSave.isVerticalSave = x.status;
              this.checkSaved();
            }
          });
        },
        rejected: x => {
          this.checkSave.isInfoSave = x.status;
          this.checkSaved();
        }
      });
    },
    resetSaved () {
      this.isLoadingButton = true;
      this.checkSave.existError = false;
      this.checkSave.isInfoSave = null;
      this.checkSave.isVerticalSave = null;
    },
    checkSaved () {
      if (this.checkSave.isInfoSave && this.checkSave.isVerticalSave) {
        this.showMessage('Datos guardados con éxito.');
        // Stop Loading Button
        this.isLoadingButton = false;
      } else if (
        (this.checkSave.isInfoSave === false ||
          this.checkSave.isVerticalSave === false) &&
        this.checkSave.existError === false
      ) {
        this.checkSave.existError = true;
        this.showError('No se han podido guardar los datos.');

        // Stop Loading Button
        this.isLoadingButton = false;
      }
    },
    async isCreate (val) {
      this.isNew = false;
      await this._callData(val);
    },
    async _callData (idAmbito) {
      this.isLoading = true;
      this.showLoading();

      let request = {
        controller: '/Ambito/' + idAmbito
      };

      await this.$store
        .dispatch('PF/getSuit', request)
        .then(response => {
          let data = response.data;
          data.id = idAmbito;
          this.dataAmbito = data;

          this.verticalSuper = response.data.verticales;

          this.isLoading = false;
          this.hideLoading();
        })
        .catch(err => {
          this.showError(err);
          this.isLoading = false;
          this.hideLoading();
        });
    },
    async _getGrupo () {
      this.isLoadingVerticals = true;
      this.showLoading();

      let request = {
        controller: '/Vertical'
      };

      await this.$store
        .dispatch('PF/getSuit', request)
        .then(response => {
          this.arrayVertical = response.data;
          this.isLoadingVerticals = false;
          this.hideLoading();
        })
        .catch(err => {
          this.showError(err);
          this.isLoadingVerticals = false;
          this.hideLoading();
        });
    }
  }
};
</script>
<style lang="scss" scoped>
#group-container {
  padding-top: 32px;
}
</style>
